<template>
  <div>
    <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 10px;">
      <h3 style="margin-bottom: 15px;"># 用户列表</h3>
      <div class="page-toolbar">
        <el-button type="primary" size="small" plain icon="el-icon-picture-outline" @click="openDefaultAvatarDialog">
          默认头像
        </el-button>
        <el-input placeholder="请输入需要搜索的用户" v-model="params.keyWord" size="small" class="input-with-select">
          <el-select v-model="userSearchType" slot="prepend" placeholder="搜索类型" style="width: 100px;">
            <el-option label="用户id" value="1"></el-option>
            <el-option label="用户昵称" value="2"></el-option>
          </el-select>
          <el-button slot="append" @click="searchUserFn" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>
    <el-dialog title="更改统一默认头像" :visible.sync="defaultAvatarShow" width="420px" append-to-body>
      <el-form label-width="90px" size="small">
        <el-form-item label="默认头像">
          <el-upload class="default-avatar-uploader" :action="uploadUrl" :headers="uploadHeaders"
            :show-file-list="false" :before-upload="beforeDefaultAvatarUpload"
            :on-success="handleDefaultAvatarSuccess" :on-error="handleDefaultAvatarError">
            <div class="default-avatar-preview">
              <img v-if="defaultAvatarForm.avatarUrl" :src="defaultAvatarForm.avatarUrl" alt="默认头像" />
              <i v-else class="el-icon-plus default-avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="defaultAvatarShow = false">取消</el-button>
        <el-button type="primary" :loading="defaultAvatarSaving" @click="submitDefaultAvatar">保存</el-button>
      </span>
    </el-dialog>
    <div class="elTableBox">
      <!-- 表格 -->
      <el-table class="columnClassNav" align="center" :data="tableData" border>
        <el-table-column fixed type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column fixed prop="userid" label="用户id" align="center" width="130">
        </el-table-column>
        <el-table-column prop="name" label="用户昵称" align="center" width="160">
        </el-table-column>
        <el-table-column prop="isVirtual" label="虚拟用户?" align="center" width="90">
          <template slot-scope="tableData">
            <el-tag size="small">{{ tableData.row.isVirtual ? '是' : '否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户头像" align="center" width="90">
          <template slot-scope="tableData">
            <el-image v-if="tableData.row.userPicture" style="width: 40px; height: 40px"
              :src="tableData.row.userPicture" fit="cover"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="useridStatus" align="center" label="状态" width="80">
          <template slot-scope="tableData">
            <el-tag :type="userStatusTagType(tableData.row)">
              {{ userStatusText(tableData.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 
        <el-table-column prop="isAdmin" align="center" label="超级管理员" width="100">
          <template slot-scope="tableData">
            <el-switch v-model="tableData.row.isAdmin" @change="switchChange(tableData.row)"></el-switch>
          </template>
        </el-table-column> -->

        <el-table-column prop="balance" align="center" label="余额">
        </el-table-column>
        <el-table-column prop="points" align="center" label="积分">
        </el-table-column>
        <el-table-column prop="gradeName" align="center" label="等级" width="90">
        </el-table-column>
        <el-table-column align="center" label="隐私开关" width="80">
          <template slot-scope="tableData">
            <span
              :style="{ color: tableData.row.privacy == null ? 'green' : tableData.row.privacy.fansSwitch ? 'green' : 'red' }">
              {{ tableData.row.privacy == null ? '开启' : tableData.row.privacy.fansSwitch ? '开启' : '关闭' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="性别" width="60">
          <template slot-scope="tableData">
            {{ tableData.row.sex == 1 ? '男' : tableData.row.sex == 2 ? '女' : '未知' }}
          </template>
        </el-table-column>
        <el-table-column prop="city" align="center" label="登录地">
        </el-table-column>

        <el-table-column prop="regTime" align="center" width="180" label="注册时间">
          <template slot-scope="tableData">
            {{ tableData.row.regTime ? tableData.row.regTime : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="enterTime" align="center" width="180" label="最后进入时间">
          <template slot-scope="tableData">
            {{ tableData.row.enterTime ? tableData.row.enterTime : '--' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-dropdown @command="handleCommand($event, scope.row)" v-if="!adminShow">
              <el-button plain size="mini" round type="primary">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="editUser">编辑用户</el-dropdown-item>
                <el-dropdown-item command="muteUser">禁言操作</el-dropdown-item>
                <el-dropdown-item command="banUser">平台封禁</el-dropdown-item>
                <el-dropdown-item command="giftRecord">礼物记录</el-dropdown-item>
                <el-dropdown-item command="taskComplteLog">任务完成详情</el-dropdown-item>
                <el-dropdown-item command="walletDetail">钱包明细</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown @command="setAppoint($event, scope.row)" v-else>
              <el-button plain size="mini" round type="primary">
                任命<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="0">任命管理员</el-dropdown-item>
                <el-dropdown-item command="1">任命圈主</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div style="text-align: right;margin: 20px 20px 0 0;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="params.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="params.pageSize"
        layout="total, sizes, prev, pager, next" :total="total_pages">
      </el-pagination>
    </div>
    <!-- 修改用户信息对话框 -->
    <el-dialog class="edit-user-dialog" title="编辑用户" :visible.sync="editUserShow" width="920px" append-to-body>
      <div class="edit-user-layout">
        <div class="user-summary-panel">
          <div class="summary-avatar-wrap">
            <el-image v-if="nowUserInfoData.userPicture" class="summary-avatar" :src="nowUserInfoData.userPicture"
              fit="cover"></el-image>
            <div v-else class="summary-avatar avatar-placeholder">
              <i class="el-icon-user"></i>
            </div>
          </div>
          <div class="summary-name">{{ nowUserInfoData.name || '--' }}</div>
          <div class="summary-tags">
            <el-tag size="mini" :type="userStatusTagType(nowUserInfoData)">
              {{ userStatusText(nowUserInfoData) }}
            </el-tag>
            <el-tag v-if="nowUserInfoData.isVirtual" size="mini" type="info">虚拟用户</el-tag>
          </div>
          <div class="summary-meta">
            <div class="summary-item">
              <span>余额</span>
              <strong>{{ nowUserInfoData.balance || 0 }}</strong>
            </div>
            <div class="summary-item">
              <span>积分</span>
              <strong>{{ nowUserInfoData.points || 0 }}</strong>
            </div>
          </div>
          <div class="summary-info">
            <div><i class="el-icon-location-outline"></i>{{ nowUserInfoData.city || '未知地区' }}</div>
            <div>性别：{{ nowUserInfoData.sex == 1 ? '男' : nowUserInfoData.sex == 2 ? '女' : '未知' }}</div>
          </div>

          <div style="text-align: left;">
            用户ID:  <span style="color: #bf5e5e;">{{ nowUserInfoData.userid || '--' }}</span>
          </div>
          <div class="summary-profile">
            <div class="summary-profile-label">个性签名</div>
            <p>{{ nowUserInfoData.profile || '暂无' }}</p>
          </div>
        </div>

        <div class="user-edit-panel">
          <el-form ref="form" :model="editUserform" label-width="86px" size="small" :rules="rules">
            <div class="form-section">
              <div class="form-section-title">基础资料</div>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="昵称" prop="name">
                    <el-input maxlength="15" v-model="editUserform.name" placeholder="请输入昵称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="等级" prop="grade">
                    <el-select v-model="editUserform.grade" placeholder="请选择等级">
                      <el-option v-for="item in gradeDataList" :key="item.levelId" :label="item.levelName"
                        :value="item.levelId"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col v-if="!adminShow" :span="12">
                  <el-form-item label="性别" prop="sex">
                    <el-select v-model="editUserform.sex" placeholder="请选择性别">
                      <el-option label="未知" :value="0"></el-option>
                      <el-option label="男" :value="1"></el-option>
                      <el-option label="女" :value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="生日">
                    <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      v-model="editUserform.birthday"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="手机号">
                    <el-input v-model="editUserform.mobile" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="登录地">
                    <el-input v-model="editUserform.city" placeholder="请输入登录地"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-section">
              <div class="form-section-title">账户设置</div>
              <el-row :gutter="16">
                <el-col :span="12">
                  <el-form-item label="余额">
                    <el-input v-model="editUserform.balance" disabled placeholder="暂不支持直接修改"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="积分">
                    <el-input v-model="editUserform.points" disabled placeholder="暂不支持直接修改"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="虚拟粉丝">
                    <el-input v-model="editUserform.virtuallyFanNum" placeholder="请输入虚拟粉丝数"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="提现密码">
                    <el-input v-model="editUserform.withdrealPasswrd" placeholder="请输入提现密码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="VIP到期">
                    <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                      v-model="editUserform.vipExpireTime"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="隐私开关">
                    <el-switch v-model="editUserform.privacy.fansSwitch" active-text="开启" inactive-text="关闭">
                    </el-switch>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-section">
              <div class="form-section-title">个性签名</div>
              <el-form-item label-width="0">
                <el-input type="textarea" :rows="4" v-model="editUserform.profile" maxlength="120" show-word-limit
                  placeholder="请输入个性签名"></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editUserShow = false">取 消</el-button>
        <el-button type="primary" @click="closeDialog">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="addPlatformShow" width="400px" title="平台封禁" append-to-body>
      <addPlatformBan :banCount="banCount" @platSubmit="handelPlatFn"></addPlatformBan>
    </el-dialog>

    <el-dialog :visible.sync="muteUserShow" width="400px" append-to-body center>
      <banUserMute @muteSubmit="handelMuteFn" :muteCount="muteCount" />
    </el-dialog>

    <el-dialog :visible.sync="giftRecordShow" width="70%" append-to-body center>
      <giftRecordPage v-if="giftRecordShow" :userId="editUserform.userid" @giftRecordSubmit="handelGiftRecordFn" />
    </el-dialog>

    <el-dialog :visible.sync="taskLogShow" width="70%" append-to-body center>
      <taskLog v-if="taskLogShow" :userId="editUserform.userid" />
    </el-dialog>

    <el-dialog :visible.sync="balaRecordShow" width="70%" append-to-body center>
      <div style="display: flex;align-items: center;justify-content: space-between;margin-bottom: 20px;">
        <div>
          <span style="margin-right: 20px;">
            钻石余额 :
            <span style="color: #f21a1a;font-weight: bold;">{{ editUserform.balance }}</span>
          </span>
          <span>
            积分余额 :
            <span style="color: #f21a1a;font-weight: bold;">{{ editUserform.points }}</span>
          </span>
        </div>
        <div style="display: flex;">
          <el-button type="primary" size="mini" @click="handelWithdrawFn(1)">充值钻石</el-button>
          <el-button type="primary" size="mini" @click="handelWithdrawFn(2)">扣除钻石</el-button>
          <el-button type="primary" size="mini" @click="handelWithdrawFn(3)">充值积分</el-button>
          <el-button type="primary" size="mini" @click="handelWithdrawFn(4)">扣除积分</el-button>
        </div>
      </div>
      <!--  @tab-click="handleClick" -->
      <el-tabs v-model="activeName">
        <el-tab-pane label="钻石明细" name="first">
          <div style="height: 500px;overflow: scroll;">
            <balanceRecord v-if="balaRecordShow" :userId="editUserform.userid" :nickName="editUserform.name" />
          </div>
        </el-tab-pane>
        <el-tab-pane label="积分明细" name="second">
          <div style="height: 500px;overflow: scroll;">
            <pointsRecord v-if="balaRecordShow" :userId="editUserform.userid" :nickName="editUserform.name" />
          </div>
        </el-tab-pane>
      </el-tabs>

      <el-dialog :visible.sync="withdrawShow" width="400px" append-to-body center
        :title="rechargeForm.type == 1 ? '充值钻石' : rechargeForm.type == 2 ? '扣除钻石' : rechargeForm.type == 3 ? '充值积分' : '扣除积分'">
        <el-form :label-position="labelPosition" label-width="80px" :model="rechargeForm">
          <el-form-item label="数量">
            <el-input v-model="rechargeForm.money" placeholder="请输入..."></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="rechargeForm.remark" placeholder="请输入..."></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="withdrawSubFn">确 定</el-button>
            <el-button @click="withdrawShow = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import taskLog from '@/views/myUse/taskCenterPage/taskLog.vue'
import addPlatformBan from './components/addPlatformBan.vue'
import banUserMute from './components/banUserMute.vue'
import giftRecordPage from './components/giftRecordPage.vue'
import balanceRecord from './components/balanceRecord.vue'
import pointsRecord from './components/pointsRecord.vue'
import '@/assets/icon/iconfont.css'
import { uploadFileUrl } from '@/api/common'
import { getToken } from '@/utils/lostorage'
import { OperationLog, setUserAdminApi, getUserGradeListApi, simpleListApi } from '@/api/user'
import { addBanUserApi, setUserMuteApi } from '@/api/circle'
import { addVirtualUserApi } from '@/api/virtual'
import { getMuteCountApi, getBanCountApi } from '@/api/superAdmin'
import { manualRecharge, manualPointsRecharge } from '@/api/withdraw'
import { getDefaultAvatar, saveDefaultAvatar } from '@/api/setting'
export default {
  name: 'wyqHome',
  components: { addPlatformBan, banUserMute, giftRecordPage, taskLog, balanceRecord, pointsRecord },
  props: {
    adminShow: { type: Boolean, default: false }
  },
  computed: {
    uploadUrl() {
      return uploadFileUrl
    },
    uploadHeaders() {
      return { token: getToken() }
    }
  },
  data() {
    return {
      tableData: [],
      // 对话框
      editUserShow: false,
      total_pages: 0,
      params: { pageNum: 1, pageSize: 10, keyWord: '' },
      muteUserShow: false,
      addPlatformShow: false,
      giftRecordShow: false,
      editUserform: {
        userPicture: '',
        birthday: '',
        sex: '',
        grade: '',
        city: '',
        profile: '',
        name: '',
        balance: '',
        virtuallyFanNum: '',
        privacy: { fansSwitch: false },
      },
      nowUserInfoData: {},
      rules: {
        name: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        grade: [{ required: true, message: '请选择等级', trigger: 'change' }],
        balance: [{ required: true, message: '请输入余额', trigger: 'blur' }],
      },
      taskLogShow: false,
      balaRecordShow: false,
      gradeDataList: [],
      muteCount: 0,
      banCount: 0,
      userSearchType: '2',
      rechargeForm: { userId: '', money: '', remark: '', type: 1 }, // type 1=充值，2=扣除
      withdrawShow: false,
      activeName: 'first',
      defaultAvatarShow: false,
      defaultAvatarSaving: false,
      defaultAvatarForm: {
        avatarUrl: ''
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    openDefaultAvatarDialog() {
      this.defaultAvatarShow = true
      this.defaultAvatarForm.avatarUrl = ''
      getDefaultAvatar().then(res => {
        this.defaultAvatarForm.avatarUrl = res.data || res.msg || ''
      }).catch(err => {
        this.$message.error(err || '默认头像获取失败, 请重试')
      })
    },
    beforeDefaultAvatarUpload(file) {
      const isImage = file.type && file.type.startsWith('image/')
      const isLt3M = file.size / 1024 / 1024 < 3
      if (!isImage) {
        this.$message.error('只能上传图片格式文件')
        return false
      }
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB')
        return false
      }
      return true
    },
    handleDefaultAvatarSuccess(response) {
      const avatarUrl = response && response.data && response.data.url
      if (!avatarUrl) {
        this.$message.error('上传成功但未返回图片地址')
        return
      }
      this.defaultAvatarForm.avatarUrl = avatarUrl
      this.$message.success('头像上传成功')
    },
    handleDefaultAvatarError() {
      this.$message.error('头像上传失败，请重试')
    },
    submitDefaultAvatar() {
      if (!this.defaultAvatarForm.avatarUrl) {
        this.$message.error('请先上传默认头像')
        return
      }
      this.defaultAvatarSaving = true
      saveDefaultAvatar(this.defaultAvatarForm.avatarUrl).then(res => {
        if (res.code == 200) {
          this.$message.success('默认头像保存成功')
          this.defaultAvatarShow = false
        } else {
          this.$message.error(res.msg || '默认头像保存失败')
        }
      }).catch(err => {
        this.$message.error(err || '默认头像保存失败')
      }).finally(() => {
        this.defaultAvatarSaving = false
      })
    },
    setAppoint(command, row) {
      this.$emit('setAppoint', command, row)
    },
    userStatusText(row) {
      if (!row) return '正常'
      if (row.deactivationStatus == 2 || row.useridStatus == 2) return '注销'
      if (row.deactivationStatus == 1) return '注销中'
      return row.useridStatus == 1 ? '封号' : '正常'
    },
    userStatusTagType(row) {
      if (!row) return 'success'
      if (row.deactivationStatus == 2 || row.useridStatus == 2) return 'info'
      if (row.deactivationStatus == 1) return 'warning'
      return row.useridStatus == 1 ? 'danger' : 'success'
    },
    getGradeListFn() {
      getUserGradeListApi({ pageNum: 1, pageSize: 20 }).then(res => {
        if (res.code == 200) {
          this.gradeDataList = res.data.records
        } else {
          this.$message({ type: 'error', message: res.msg });
        }
      }).catch(err => {
        this.$message.error(err || '请求失败, 请重试');
      })
    },
    handelWithdrawFn(type) {
      this.withdrawShow = true;
      this.rechargeForm.type = type;
      this.rechargeForm.userId = this.editUserform.userid;
      this.rechargeForm.money = 0;
      this.rechargeForm.remark = '系统赠送';
    },
    async withdrawSubFn() {
      let res;
      try {
        if (this.rechargeForm.type < 3) {
          res = await manualRecharge(this.rechargeForm)
        } else {
          let opt = {
            userId: this.rechargeForm.userId,
            points: this.rechargeForm.money,
            remark: this.rechargeForm.remark,
            type: this.rechargeForm.type == 3 ? 1 : 2,
          }
          res = await manualPointsRecharge(opt)
        }
        if (res.code == 200) {
          this.$message({ type: 'success', message: '操作成功' });
          this.withdrawShow = false;
          this.balaRecordShow = false;
          this.getData();
        } else {
          this.$message({ type: 'error', message: res.msg });
        }
      } catch {
        this.$message.error(err || '请求失败, 请重试');
      }
    },
    searchUserFn() {
      if (!this.params.keyWord) {
        this.getData()
        return;
      }
      if (this.userSearchType == '1') {
        simpleListApi({ userId: this.params.keyWord }).then(res => {
          if (res.code == 200) {
            this.tableData = [res.data]
          } else {
            this.$message.error(res.msg || '该用户不存在');
          }
        }).catch(err => {
          this.$message.error(err || '请求失败, 请重试');
        })
      } else {
        this.getData()
      }
    },
    // 更新用户超级管理员权限
    switchChange(row) {
      const that = this;
      setUserAdminApi(row.userid, row.isAdmin ? 1 : 2).then(res => {
        if (res.code == 200) {
          that.getData();
          that.$message({ type: 'success', message: '操作成功' });
        } else {
          that.$message({ type: 'error', message: res.msg });
        }
      }).catch(err => {
        that.$message({ type: 'error', message: '操作失败' });
      })
    },
    // 禁言函数
    handelMuteFn(data) {
      const that = this;
      data.userId = that.editUserform.userid
      setUserMuteApi(data).then(res => {
        that.muteUserShow = false;
        if (res.code == 200) {
          that.getData();
          that.$message({ type: 'success', message: '操作成功' });
        } else {
          that.$message({ type: 'error', message: res.msg });
        }
      }).catch(err => {
        that.muteUserShow = false;
      })
    },
    // 封禁函数
    handelPlatFn(data) {
      const that = this;
      data.userId = that.editUserform.userid
      addBanUserApi(data).then(res => {
        that.addPlatformShow = false;
        if (res.code == 200) {
          that.getData();
          that.$message({ type: 'success', message: '操作成功' });
        } else {
          that.$message({ type: 'error', message: res.msg });
        }
      }).catch(err => {
        that.addPlatformShow = false;
      })
    },
    handleCommand(command, row) {
      this.editUserform = JSON.parse(JSON.stringify(row))
      this.nowUserInfoData = { ...row }
      if (this.editUserform.privacy == null) {
        this.editUserform.privacy = { fansSwitch: true }
      }
      if (command === 'editUser') {
        this.editUserShow = true
        if (!this.gradeDataList.length) {
          this.getGradeListFn()
        }
      } else if (command === 'muteUser') {
        this.muteUserShow = true
        getMuteCountApi(this.editUserform.userid).then(res => {
          if (res.code == 200) {
            this.muteCount = res.data
          } else {
            this.$message.error(res.msg || '禁言总数获取失败, 请重试~')
          }
        }).catch((err) => {
          this.$message.error(err || '禁言总数获取失败, 请重试~')
        })
      } else if (command === 'banUser') {
        this.addPlatformShow = true
        getBanCountApi(this.editUserform.userid).then(res => {
          if (res.code == 200) {
            this.banCount = res.data
          } else {
            this.$message.error(res.msg || '封禁总数获取失败, 请重试~')
          }
        }).catch((err) => {
          this.$message.error(err || '封禁总数获取失败, 请重试~')
        })
      } else if (command === 'giftRecord') {
        this.giftRecordShow = true
      } else if (command === 'taskComplteLog') {
        this.taskLogShow = true
      } else if (command === 'walletDetail') {
        this.balaRecordShow = true
      }
    },
    handleCurrentChange(number) {
      this.params.pageNum = number;
      this.getData();
    },
    handleSizeChange(size) {
      if (this.total_pages >= size) {
        this.params.pageSize = size;
        this.getData();
      }
    },
    getData() {
      OperationLog(this.params).then(res => {
        if (res.code == 200) {
          this.tableData = res.data.records;
          this.total_pages = res.data.total;
        } else {
          this.$message.error(res.msg || '操作失败');
        }
      }).catch(err => this.$message.error(err || '请求失败, 请重试'));
    },
    // 修改信息提交事件
    async closeDialog() {
      this.$confirm('此操作将变更改用户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const fansSwitch = this.editUserform.privacy ? this.editUserform.privacy.fansSwitch : true
        this.editUserform.privacy = {
          homeSwitch: fansSwitch,
          fansSwitch,
          followSwitch: fansSwitch,
          postComPerm: 'ALL',
          friendMsgSwitch: true,
          strangerSwitch: true
        }
        addVirtualUserApi(false, this.editUserform).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '操作成功' });
            this.editUserShow = false
            this.getData()
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        }).catch(err => this.$message.error(err || '请求失败, 请重试'))
      }).catch(() => { });


    }
  }
}
</script>

<style scoped lang="scss">
.elTableBox {
  display: flex;
  width: 100%;
  padding-right: 20px;
}

.el-select .el-input {
  width: 130px;
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.page-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 20px;
}

.default-avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 50%;
    cursor: pointer;
    overflow: hidden;
  }

  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
}

.default-avatar-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 112px;
  height: 112px;
  background: #f5f7fa;
  border-radius: 50%;

  img {
    width: 112px;
    height: 112px;
    object-fit: cover;
    border-radius: 50%;
  }
}

.default-avatar-uploader-icon {
  color: #8c939d;
  font-size: 28px;
}

.edit-user-dialog {
  ::v-deep .el-dialog__body {
    padding: 18px 20px 8px;
    background: #f5f7fa;
  }
}

.edit-user-layout {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 16px;
}

.user-summary-panel,
.user-edit-panel {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  box-sizing: border-box;
}

.user-summary-panel {
  padding: 20px 16px;
  text-align: center;
}

.summary-avatar-wrap {
  display: flex;
  justify-content: center;
}

.summary-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  border: 1px solid #ebeef5;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9eef3;
  color: #909399;
  font-size: 34px;
}

.summary-name {
  margin-top: 14px;
  color: #303133;
  font-size: 18px;
  font-weight: 600;
  word-break: break-word;
}

.summary-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.summary-meta {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 18px;
}

.summary-item {
  padding: 10px 8px;
  background: #f5f7fa;
  border-radius: 4px;

  span {
    display: block;
    color: #909399;
    font-size: 12px;
  }

  strong {
    display: block;
    margin-top: 6px;
    color: #303133;
    font-size: 16px;
  }
}

.summary-info {
  margin-top: 16px;
  color: #606266;
  line-height: 1.9;
  text-align: left;

  i {
    margin-right: 4px;
  }
}

.summary-profile {
  margin-top: 14px;
  padding: 12px;
  color: #606266;
  text-align: left;
  background: #fafafa;
  border: 1px solid #ebeef5;
  border-radius: 4px;

  p {
    margin: 8px 0 0;
    line-height: 1.6;
    word-break: break-word;
  }
}

.summary-profile-label {
  color: #909399;
  font-size: 12px;
}

.user-edit-panel {
  padding: 16px 18px 2px;

  ::v-deep .el-select,
  ::v-deep .el-date-editor.el-input,
  ::v-deep .el-input {
    width: 100%;
  }
}

.form-section {
  margin-bottom: 18px;
  padding-bottom: 4px;
  border-bottom: 1px solid #ebeef5;

  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }
}

.form-section-title {
  margin-bottom: 14px;
  color: #303133;
  font-weight: 600;
}

@media (max-width: 960px) {
  .edit-user-layout {
    grid-template-columns: 1fr;
  }
}
</style>
